const logotext = "MARUFA";
const meta = {
    title: "Marufa Akter Eity",
    description: "I’m Marufa Akter Eity data scientist _ Full stack developer,currently working in Dhaka",
};

const introdata = {
    title: "I’m Marufa Akter Eity",
    animated: {
        first: "I love coding",
        second: "I code cool websites",
        third: "I develop Professional Websites",
    },
    description: "Passionate frontend developer crafting dynamic web apps with clean code, MERN stack expertise, and a drive for continuous learning.",
    your_img_url: "https://i.ibb.co/LhbfC1pv/Profile-img.png",
};

const dataabout = {
    title: " about my self",
    aboutme: "I'm a passionate Frontend Engineer with a strong focus on building dynamic and user-friendly web applications. My journey began with HTML, CSS, and JavaScript, and I hold a B.Sc. in Computer Science. Currently, I'm excelling at Kompass Technology Limited, where I specialize in the MERN stack (MongoDB, Express.js, React, Node.js) along with MySQL. I’m always eager to learn, grow, and bring ideas to life through clean, efficient code.",
};
// const worktimeline = [{
//         jobtitle: "Designer of week",
//         where: "YAdfi",
//         date: "2020",
//     },
//     {
//         jobtitle: "Designer of week",
//         where: "Jamalya",
//         date: "2019",
//     },
//     {
//         jobtitle: "Designer of week",
//         where: "ALquds",
//         date: "2019",
//     },
// ];

const skills = [{
        name: "HTML",
        value: 100,
    },
    {
        name: "CSS",
        value: 95,
    },
    {
        name: "Javascript",
        value: 90,
    },
    {
        name: "React",
        value: 90,
    },
    {
        name: "Next",
        value: 80,
    },
    {
        name: "TypeScript",
        value: 50,
    },
    {
        name: "Node",
        value: 50,
    },
    {
        name: "Express",
        value: 60,
    },
    {
        name: "Mongodb",
        value: 50,
    },
    {
        name: "Photoshop",
        value: 60,
    },
    {
        name: "Illustrator",
        value: 60,
    },
  
    {
        name: "Figma",
        value: 50,
    },
  
    {
        name: "Github version",
        value: 70,
    },
    {
        name: "Docker",
        value: 50,
    },
  
];

const services = [{
        title: "Responsive Website Design",
        description: "Designing responsive websites that adapt seamlessly to all devices, ensuring user-friendly experiences, modern layouts, and mobile-first performance with efficiency.",
    },
];


const contactConfig = {
    YOUR_EMAIL: "marufa.webdev@gmail.com",
    YOUR_FONE: "01825897301",
    description: "West Rampura,Dhaka-1219,Bangladesh ",
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    github: "https://github.com/Eity2021",
    linkedin: "https://www.linkedin.com/in/marufa-akter-eity607/",
    twitter: "https://x.com/graphic17460515",
};
export {
    meta,
    dataabout,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};